import FilterMenuButton from '@components/filters/FilterMenuButton';
import OptionFilterPanel from '@components/filters/OptionFilterPanel';
import { FilterState, FilterKey, FILTER_OPTIONS, FILTER_LABELS } from './filterState';

type AgenciesFilterMenuButtonProps = {
  filterState: FilterState;
  onFilterChange: (newState: FilterState) => void;
};

const AgenciesFilterMenuButton: React.FC<AgenciesFilterMenuButtonProps> = ({ filterState, onFilterChange }) => {
  const menuItems = (Object.keys(FILTER_LABELS) as FilterKey[]).map((key) => ({
    key,
    label: FILTER_LABELS[key],
    panelContent: (
      <OptionFilterPanel
        options={FILTER_OPTIONS[key]}
        selected={filterState[key]}
        onChange={(newSelected) => onFilterChange({ ...filterState, [key]: newSelected })}
      />
    ),
  }));

  return <FilterMenuButton menuItems={menuItems} />;
};

export default AgenciesFilterMenuButton;
